<template>
  <header :class="{border: hasBorder}">
    <img v-if="backBtn" class="img-left" @click="goDetail" src="../../assets/img/detail/arrow-left.svg" alt="">
    <img v-if="homeBtn" class="img-left" @click="goHome" src="../../assets/img/detail/arrow-left.svg" alt="">
    <h1>{{title}}</h1>
    <img v-if="shareBtn" class="img-right" src="../../assets/img/detail/share.svg" alt="" @click="share">
    <a v-if="serviceBtn" class="img-right">
      <img src="../../assets/img/detail/service-black.svg" alt="" @click="service">
    </a>
  </header>
</template>

<script>
  import config from "../../util/config";
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      backBtn: {
        type: Boolean,
        default: false
      },
      homeBtn: {
        type: Boolean,
        default: false
      },
      shareBtn: {
        type: Boolean,
        default: false
      },
      serviceBtn: {
        type: Boolean,
        default: false
      },
      hasBorder: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        msgUrl: config.msgUrl
      }
    },
    methods: {
      /**
       * 分享
       */
      share() {
        this.$emit('share');
      },
      /**
       * 客服
       */
      service() {
        if(cConf.serviceLineMe) {
          window.open('https://line.me/ti/p/UnTgQVExys#~')
        } else {
          window.open(this.msgUrl)
        }
        this.$emit('service');
      },
      /**
       * 返回详情页面
       */
      goDetail() {
        this.$router.push({
          path: '/detail',
          query: {
            id: this.$route.query.id,
            path: this.$route.query.path,
          }
        });
      },
      /**
       * 返回首页
       */
      goHome() {
        let defaultHome = '/static/home.html';
        const host = location.host
        // const reg = /.*?([a-z0-9--]{1,200}.com)$/
        // const homeConfig = {
        //   "qualitygogo.com": "//my.qualitygogo.com/promotion/spring-sale-my",
        //   "golifestoretw.com": "//th.golifestoretw.com/promotion/spring-thai",
        //   "17ihome.com": "//thai.17ihome.com/promotion/sale-thai-21",
        //   "soanclothes.com": "//thai.soanclothes.com/promotion/clothes-sale-th",
        //   "americanwsh.com": "//th.americanwsh.com/promotion/sale-th2021",
        //   "warmthcorner.com": "//thai.warmthcorner.com/promotion/festival-sale21",
        //   "bluebirderr.com": "//tw.bluebirderr.com/promotion/blue-spring-sale",
        //   "stylels.com": "//tw.stylels.com/promotion/twsale2021",
        //   "darkgogo.com": "//tw.darkgogo.com/promotion/mensale-2021",
        //   "twgolifestore.com": "//good.twgolifestore.com/promotion/twspringsale",
        //   "stylishhoing.com": "//jp.stylishhoing.com/promotion/jp-spring-sale2021",
        //   "wshnetwork.com": "//sg.wshnetwork.com/promotion/sgonsale-2104",
        //   "pomeloinn.com": "//hk.pomeloinn.com/promotion/hongkongsale2021",
        //   "allbuythailand.com": "//thailand.allbuythailand.com/collections-big-sale"
        // }
        //
        // const regRes = host.match(reg)
        // if (regRes) {
        //   const rootHost = regRes[1];
        //   if (rootHost in homeConfig) {
        //     defaultHome = homeConfig[rootHost]
        //   }
        // }
        //
        // location.href = this.$route.query.home ? `${this.$route.query.home}?path=${this.$route.query.path || ''}` : defaultHome

        if (host !== 'localhost'){
          location.href = "https://" + host
        }else {
          location.href = 'http://localhost/'
        }
      }
    }
  }
</script>

<style scoped>
  header {
    z-index: 100;
    position: fixed;
    top: 0;
    width: 100%;
    max-width: 640px;
    height: 44px;
    background: rgb(255, 255, 255);
  }

  .border {
    border-bottom: 1px solid #eee;
  }

  .img-left {
    float: left;
  }

  .img-right {
    float: right;
    margin-left: 0;
  }

  header h1 {
    z-index: -10;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 44px;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  header img {
    width: 24px;
    margin: 10px;
    cursor: pointer;
    background: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/header.vue